import { Injectable } from "@angular/core";
import { BehaviorSubject, tap, switchMap, Observable } from "rxjs";
import { GlobalComponent } from "src/app/global-component";
import { SearchResultModel } from "../models/query/search-result-model";
import { TableConfigSearchModel } from "../models/table/searchModels/table-config-search.model";
import { BaseListService } from "./list-services/base-list.service";
import { AiApiService } from "./ai-api.service";
import { TableConfigurationModel } from "../models/table/table-configuration.model";



@Injectable({
    providedIn: 'root'
})
export class TableConfigService extends BaseListService {

    defaultTableConfigListState: TableConfigSearchModel = {
        sortColumnDirective: 'modifiedDate',
        sortDirectionDirective: 'desc',
        createdById: undefined,
        pageSize: GlobalComponent.defaultPagingInfo.pageSize,
        pageIndex: 0,
        startIndex: 0,
        sortColumn: '',
        sortDirection: 'desc',
        searchTerm: undefined,
        status: undefined,
        listTitle: undefined
    };

    private _resultItems$ = new BehaviorSubject<TableConfigurationModel[]>([]);

    protected override _state: TableConfigSearchModel = { ...this.defaultTableConfigListState };

    constructor(
        private aiApiService: AiApiService) {
        super();
        this._search$.pipe(
            tap(() => this._loading$.next(true)),
            switchMap(() => this._search()),
            tap(() => this._loading$.next(false))
        ).subscribe((result: any) => {
            this._resultItems$.next(result.items);
            this._total$.next(result.count);
        });
    }

    get resultItems$() { return this._resultItems$.asObservable(); }
    set createdById(createdById: any) { this._state.createdById = createdById }
    set listTitle(listTitle: string) { this._set({ listTitle }); }

    clearListService() {
        this._state = { ...this.defaultTableConfigListState };
        this._resultItems$.next(new Array<TableConfigurationModel>());
        this._total$.next(0);
    }

    protected _search(): Observable<SearchResultModel<TableConfigurationModel> | undefined> {

        this.validateStartIndex();

        this._state.sortColumn = this.titleCaseWord(this._state.sortColumnDirective) as string;

        return this.aiApiService.getTableConfig(this._state);
    }

}